<template>
  <v-dialog v-model="dialog" max-width="1140px">
    <v-card>
      <v-card-title class="amber darken-1 white--text"
        >Xem trước
        <v-spacer />
        <v-icon color="white" @click="cancel">close</v-icon>
      </v-card-title>
      <div style="max-wdith: 1140px" class="mx-auto">
        <v-carousel
          dark
          cycle
          :show-arrows="false"
          v-model="model"
          hide-delimiter-background
        >
          <v-carousel-item
            v-for="(item, i) in items"
            :key="i"
            transition="fade-transition"
          >
            <v-sheet max-width="1140px" tile>
              <v-row
                class="fill-height"
                align="center"
                justify="center"
                no-gutters
              >
                <card :item="item" />
              </v-row>
            </v-sheet>
          </v-carousel-item>
        </v-carousel>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import Card from './FeaturedCard.vue'

export default {
  components: {
    Card,
  },
  props: {
    state: Boolean,
    items: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      dialog: false,
      model: 0,
    }
  },
  methods: {
    cancel() {
      this.dialog = false
    },
  },
  watch: {
    state(state) {
      this.dialog = true
    },
  },
}
</script>